var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"32e2aee734310ecf28c9376cf396c07ea841b997"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["utm-tool@ds-group"]={id:"32e2aee734310ecf28c9376cf396c07ea841b997"};
      